import { ApplicationState } from '@app/store'
import {
  IGlobalSignTypesState,
  selectSignTypes,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import SignListEditor from '../components/SignListEditor'

export default connect(
  (state: ApplicationState) =>
    createStructuredSelector<ApplicationState, IGlobalSignTypesState>({
      signTypes: selectSignTypes(),
    }),
  {},
)(SignListEditor)
